<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-form ref="form" v-model="valid" >
      <v-card>
        <v-toolbar color="primary darken-1" dark>
          <v-card-title>
            <span class="">{{
              (editedIndex === -1 ? $t("add") : $t("edit")) +
              " " +
              $t("schoolGroups.schoolGroup")
            }}</span>
          </v-card-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  outlined
                  hide-details
                  persistent-hint
                  v-model="editedItem.name"
                  :rules="[rulesWithLength.required]"
                  :label="$t('schoolGroups.schoolGroupName')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            class="white--text"
            @click="save"
            :disabled="!valid || submitLoading"
            :loading="submitLoading"
            :min-width="100"
          >
            <v-icon>mdi-content-save-outline</v-icon>
            {{ $t("save") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="onClose">
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
export default {
  props: [
    "onSave",
    "onClose",
    "dialog",
    "editedItem",
    "editedIndex",
    "resetValidation",
  ],
  data() {
    return {
      valid: true,
      submitLoading: false,
      rules: {
        required: (value) => !!value || this.$t("ThisFieldIsRequired"),
      },
      rulesWithLength: {
        required: (value) =>
          (value != null && value.length < 255) ||
          this.$t("ThisFieldIsRequired"),
      },
    };
  },
  watch: {
    resetValidation() {
      this.resetForm();
    },
  },
  computed: {},
  methods: {
    resetForm() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    save() {
      var val = this.$refs.form.validate();
      if (val) {
        this.submitLoading = true;
        if (this.editedIndex > -1) {
          this.$axios
            .post(
              "UpdateSchoolGroup/" + this.editedItem.id,
              this.editedItem
            )
            .then((response) => {
              if (response.data.status == "Successful") {
                this.onClose();
                this.$emit("refreshTable");
              }
            })
              .finally(() => {
                this.submitLoading = false;
              });
        } else {
          this.$axios
            .post("AddSchoolGroup", this.editedItem)
            .then((response) => {
              if (response.data.status == "Successful") {
                this.onClose();
                this.$emit("refreshTable");
              }
            })
              .finally(() => {
                this.submitLoading = false;
              });
        }
      }
    },
  },
};
</script>
